import { getIsLoggedIn } from '@/src/features/auth/utils/getIsLoggedIn'
import { EVENT_ORIGIN } from '@/src/features/community/models/community.constants'
import { routeToPath } from '@/src/general/constants/routes'
import { useMakeIsGranted } from '@/src/general/role-access'
import { isNative } from '@/src/general/utils/isNative'
import { useRoutes } from '@/src/general/utils/routes'

import type { TPublicationApi } from '../../api/types/getPublication.types'

export const usePublicationRedirections = (publication?: TPublicationApi) => {
  const { isGranted } = useMakeIsGranted()
  const { routes } = useRoutes()

  if (!publication || !publication.community) return { redirectPath: null }

  const { id, slug } = publication.community

  const canEditContent = isGranted('canManageContent', publication.community)
  const isPublicationScheduled = publication.isScheduled && !publication.published

  if ((publication.isDraft || isPublicationScheduled) && !getIsLoggedIn()) {
    const adminCommunityRoute = routeToPath(routes.communityAdmin({ id, slug, tab: 'scheduledAndDrafts' }))
    return {
      redirectPath: isNative()
        ? routes.authConnect({ redirectTo: adminCommunityRoute })
        : routes.connect(adminCommunityRoute),
    }
  }
  if ((publication.isDraft || isPublicationScheduled) && canEditContent) {
    return { redirectPath: routes.communityAdmin({ id, slug, tab: 'scheduledAndDrafts' }) }
  }
  if ((publication.isDraft || isPublicationScheduled) && !canEditContent && getIsLoggedIn()) {
    return {
      redirectPath: routes.community({
        id,
        slug,
        origin: EVENT_ORIGIN.PUBLICATION,
        message: 'community.publication.error.publication.not-accessible',
      }),
    }
  }
  return { redirectPath: null }
}
